import React, { useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import { Box, Button, TextField } from "@mui/material";
import { ReactSession } from "react-client-session";
import { apiUrl } from "../services/api";
import { useNavigate } from "react-router-dom";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchUser = async (username, password, onLogin, setError) => {
    try {
      const response = await axios.get(`${apiUrl}/user/`, {
        params: { username },
      });
      const userData = response.data;
      if (
        username !== "" &&
        password !== "" &&
        userData.username === username &&
        userData.password === password
      ) {
        ReactSession.setStoreType("localStorage");
        ReactSession.set("id_user", userData.id_user);
        ReactSession.set("username", userData.username);
        ReactSession.set("role", userData.role);
        onLogin();
        navigate("/voiture");
      } else {
        setError("Nom d'utilisateur ou mot de passe incorrect!");
      }
    } catch (err) {
      console.error("Error fetching user:", err);
      setError("Internal Server Error");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && username !== "" && password !== "") {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    await fetchUser(username, password, onLogin, setError);
  };

  return (
    <Box m="150px" display="flex" flexDirection="column" alignItems="center">
      <Header
        title="Connexion"
        subtitle="Connecter avec votre nom d'utilisateur et votre mot de passe."
      />
      <Box m="20px" flexDirection="column" textAlign="center">
        <TextField
          style={{ marginTop: "20px", marginBottom: "20px" }}
          fullWidth
          variant="filled"
          type="text"
          label="Nom d'Utilisateur"
          onChange={(e) => setUsername(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <TextField
          style={{ marginTop: "20px", marginBottom: "20px" }}
          fullWidth
          variant="filled"
          type="password"
          label="Mot de passe"
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            style={{ width: "150px", marginTop: "20px", marginBottom: "20px" }}
            type="Button"
            color="secondary"
            variant="contained"
            onClick={handleLogin}
          >
            Connexion
          </Button>
        </Box>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </Box>
    </Box>
  );
};

export default Login;
